<template>
   
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              <div></div>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button v-focus type="" 
                class="btn btn-lg btn-primary"
                @click="$emit('close')">
                weiter
              </button>

              <button type="" 
                class="btn btn-default"
                @click="$emit('abort')">
                zurück
              </button>

            </slot>
          </div>
          
        </div>
      </div>
    </div>
  </transition>

</template>



<script>

import bus from './common/bus'

export default {
  
  data () {
    return {
      
      
    }
  },
  
  
  created: function () {
  },
  
  
  methods: {
    
  },

}
  
</script>



<style scoped>

 .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 90%;
  margin: 0px auto;
  padding: 80px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  margin: 20px 0;
  overflow:auto;
}

.modal-footer {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid lightgray;
  text-align: right;
}

  .modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

  

</style>



// WEBPACK FOOTER //
// CompanyClientStartModal.vue?0ac323f8